__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/079f772/_next/";